import React from 'react';
import randomstring from 'uuid/v4';

import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Fab from '@material-ui/core/Fab';

import { BlueTickIcon, BlueCloseIcon, AddIcon, EditIcon, TrashIcon } from '../../../images/icons/WrapSvg';
import CurrentTab from './EditCurrentTab';
import DialogWidget from './DialogWidget';
import DialogName from '../../dialogs/DialogName';

// eslint-disable-next-line
import style from './_styles.css';

function toolbar(handleCancel, summit, handleSummit) {
    const aux = [];
    if (summit) {
        aux.push(
            <BlueTickIcon
                key="submmit-save-employee"
                className="hand"
                color="primary"
                onClick={handleSummit}
            />
        );
    }
    aux.push(
        <BlueCloseIcon
            key="submmit-cancel-dashboard"
            className="hand"
            color="secondary"
            onClick={handleCancel}
        />
    );
    return aux;
}

class Editdashboard extends React.Component {
    state = {
        active: 0,
        edit: false,
        dashboard: undefined,
        popup: undefined,
        updated: false,
        open: false
    };

    componentDidMount() {
        const tools = [toolbar(this.handleCancel, false, this.handleSummit)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { dashboard } = props;

        if (dashboard !== state.dashboard && state.dashboard === undefined) {
            state.dashboard = dashboard;
            state.activetab = dashboard.length > state.active ? dashboard[state.active] : undefined;
            return state;
        }
        return null;
    }

    handleChange = (value) => {
        const { dashboard } = this.state;
        if (dashboard.length <= value) return false;
        this.setState({ active: value, activetab: (dashboard.length > 0 ? dashboard[value] : undefined) });
    }

    handleAddorEdit = (name) => {
        if (name) {
            const { dashboard, popup, active, activetab, updated } = this.state;

            let current = activetab;
            let id = active;
            const arr = [...dashboard];

            if (popup === true) {
                current = {
                    pestana: name,
                    widgets: []
                }
                id = dashboard.length;
                arr.push(current);
            } else {
                current.pestana = name;
                arr[id] = current;
            }

            if (!updated) {
                const tools = [toolbar(this.handleCancel, true, this.handleSummit)];
                this.props.setTools(tools);
            }

            this.setState({ active: id, activetab: current, dashboard: arr, popup: false, updated: true });
        } else {
            this.setState({ popup: false });
        }
    }

    handleAddPopup = () => {
        this.setState({ popup: true });
    }

    handleDeleteTitleActive = () => {
        const { dashboard, active, updated } = this.state;
        const id = active > 0 ? active - 1 : 0;
        dashboard.splice(active, 1);

        if (!updated) {
            const tools = [toolbar(this.handleCancel, true, this.handleSummit)];
            this.props.setTools(tools);
        }

        this.setState({ active: id, activetab: dashboard[id], dashboard: dashboard, update: true });
    }

    handleEditTitleActive = () => {
        const { activetab } = this.state;
        this.setState({ popup: activetab.pestana });
    }

    handleCancel = () => {
        this.props.onCancel(false);
    }

    handleSummit = () => {
        this.props.onSummit(this.state.dashboard);
    }

    handleOpenWidget = (value) => {
        console.log(value);
        this.setState({ open: value });
    }

    handleDeleteWidget = (widget) => {
        const { dashboard, active, activetab, updated } = this.state;

        const index = activetab.widgets.indexOf(widget);
        if (index > -1) {
            activetab.widgets.splice(index, 1);
        }
        dashboard[active] = activetab;

        if (!updated) {
            const tools = [toolbar(this.handleCancel, true, this.handleSummit)];
            this.props.setTools(tools);
        }

        this.setState({ activetab: activetab, dashboard: dashboard, update: true });

    }

    handleWidget = (nombre, origen, tipo, metadatos) => {
        const { open, activetab, active, dashboard, updated } = this.state;

        console.log(nombre, origen, tipo, metadatos);

        const widget = {
            id: open === true ? activetab.widgets.length : open.id,
            nombre: nombre,
            origen: origen,
            tipo: tipo,
            metadatos: metadatos
        };

        if (nombre) {

            if (open === true) {
                activetab.widgets.push(widget);
            } else {
                activetab.widgets[open.id] = widget;
            }
            dashboard[active] = activetab;

            if (!updated) {
                const tools = [toolbar(this.handleCancel, true, this.handleSummit)];
                this.props.setTools(tools);
            }

            this.setState({ open: false, activetab: activetab, dashboard: dashboard, update: true });
        } else {
            this.setState({ open: false });
        }
    }

    // a little function to help us with reordering the result
    handleReorder = (startIndex, endIndex) => {
        const { activetab, active, dashboard, updated } = this.state;

        const result = Array.from(activetab.widgets);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        activetab.widgets = result.map((w, i) => {
            w.id = i;
            return w;
        })

        dashboard[active] = activetab;

        if (!updated) {
            const tools = [toolbar(this.handleCancel, true, this.handleSummit)];
            this.props.setTools(tools);
        }

        this.setState({ activetab: activetab, dashboard: dashboard, update: true });
    };

    render() {
        const { dashboard, active, activetab, popup, open } = this.state;

        const Label = ({ name, active, index, more }) => {
            if (active === index) {
                return (
                    <div className="center">
                        <span> {name} </span>
                        <EditIcon
                            className="margin_left_12"
                            color="primary"
                            fontSize="small"
                            onClick={this.handleEditTitleActive}
                        />
                        {more && <TrashIcon
                            className="margin_left_12"
                            color="secondary"
                            fontSize="small"
                            onClick={this.handleDeleteTitleActive}
                        />
                        }
                    </div>
                );
            } else {
                return (<span> {name} </span>);
            }
        }
        return (
            <div id="editdasboard" className="width100 height100 adapt">
                <Paper square>
                    <Tabs
                        value={active}
                        variant="scrollable"
                        scrollButtons="on"
                        indicatorColor="primary"
                        aria-label="scrollable auto tabs example"
                        className="backgroundColorTabs"
                    >
                        {dashboard && dashboard.length > 0 &&
                            dashboard.map((tab, index) => (
                                <Tab
                                    className="barlowcondensed_medium"
                                    key={randomstring()}
                                    label={<Label name={tab.pestana} active={active} index={index} more={dashboard.length > 1} />}
                                    value={index}
                                    onClick={() => this.handleChange(index)}
                                />
                            ))
                        }
                    </Tabs>
                </Paper>
                {activetab &&
                    <CurrentTab
                        {...this.props}
                        key={randomstring()}
                        tab={activetab}
                        edit
                        onAdd={this.handleOpenWidget}
                        onDelete={this.handleDeleteWidget}
                        onReorder={this.handleReorder}
                    />
                }
                {popup &&
                    <DialogName
                        name={popup === true ? '' : popup}
                        onClose={this.handleAddorEdit}
                    />
                }
                {open &&
                    <DialogWidget
                        {...this.props}
                        widget={open === true ? undefined : open}
                        onClose={this.handleWidget}
                    />
                }
                <Fab
                    color="primary"
                    aria-label="add"
                    className={'button_float'}
                    onClick={this.handleAddPopup}
                >
                    <AddIcon />
                </Fab>
            </div>
        );
    }
}

export default Editdashboard;



// WEBPACK FOOTER //
// ./src/components/complex/dashboard/Editdashboard.js